module.exports = __webpack_public_path__ + "img/J.423e2176.png";